import classNames from 'classnames';
import { DeliveryTime } from '@hub/libs/constants';
import { useTranslation } from 'next-i18next';
import { Icon, IconColor, IconID } from '@hub/common/Icon/Icon';

interface DeliveryInfoProps {
  deliveryTimeCode?: DeliveryTime;
  deliveryTimeText?: string;
}

interface DeliveryTimeIconLayout {
  statusColor: string;
  iconColor: IconColor;
  iconID: IconID;
}

export const getDeliveryTimeIconLayout = (deliveryTimeCode: DeliveryTime): DeliveryTimeIconLayout => {
  switch (deliveryTimeCode) {
    case DeliveryTime.FASTLANE:
      return {
        statusColor: 'text-availability-fastlane',
        iconColor: IconColor.DELIVERY_FASTLANE,
        iconID: IconID.DELIVERY_TIME_DOT,
      };
    case DeliveryTime.FAST:
      return {
        statusColor: 'text-availability-fast',
        iconColor: IconColor.DELIVERY_FAST,
        iconID: IconID.DELIVERY_TIME,
      };
    case DeliveryTime.SLOW:
      return {
        statusColor: 'text-availability-slow',
        iconColor: IconColor.DELIVERY_SLOW,
        iconID: IconID.DELIVERY_TIME,
      };
    case DeliveryTime.ON_REQUEST:
    default:
      return {
        statusColor: 'text-availability-on-request',
        iconColor: IconColor.GRAY,
        iconID: IconID.DELIVERY_TIME,
      };
  }
};

export const DeliveryInfo = ({ deliveryTimeCode = DeliveryTime.ON_REQUEST, deliveryTimeText }: DeliveryInfoProps) => {
  const { t } = useTranslation('product/deliveryInfo');
  const { statusColor, iconColor, iconID } = getDeliveryTimeIconLayout(deliveryTimeCode);

  return (
    <span data-testid="delivery-info" className={classNames('flex', 'flex-row', statusColor)}>
      <div className="p-1 mr-2">
        <Icon id={iconID} size={8} color={iconColor} />
      </div>
      <div className="pt-1" data-testid="delivery-info-text">
        {deliveryTimeText || t('DELIVERY_INFO.DELIVERYTIME_ON_REQUEST')}
      </div>
    </span>
  );
};
